export default {
  data: function data() {
    return {
      dialogVisible: false
    };
  }
};